module.exports = __webpack_public_path__ + "static/ss4.c34210da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss4.png
// module id = 1167
// module chunks = 112875127094159